import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {To, useNavigate} from 'react-router-dom';

interface UnfinishedFormPromptProps {
  buttonLabel?: string;
  disagree?: string;
  agree?: string;
  dirty: boolean;
  // A route to navigate to, or a history delta (e.g. -1 to go back).
  path: To | number;
  ariaLabel?: string;
}

/**
 * Asks if the user wants to navigate away.
 */
export default function UnfinishedFormPrompt({
  buttonLabel = 'Exit without Saving',
  disagree = 'Cancel',
  agree = 'Leave',
  dirty,
  path,
  ariaLabel,
}: UnfinishedFormPromptProps): JSX.Element {
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();

  const goToPath = () => {
    if (typeof path === 'number') {
      navigate(path);
    } else {
      navigate(path);
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Button
        variant="outlined"
        aria-label={ariaLabel}
        color="primary"
        onClick={(e) => {
          if (e.altKey) {
            goToPath();
            return;
          }
          if (!dirty) {
            goToPath();
          } else {
            handleClickOpen();
          }
        }}
      >
        {buttonLabel}
      </Button>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Navigate away?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            You have unsaved changes, are you sure you want to leave?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {disagree}
          </Button>
          <Button
            onClick={() => {
              goToPath();
              handleClose();
            }}
            color="primary"
            autoFocus
            variant="contained"
          >
            {agree}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
